import React, { FC } from "react";
import styles from "./TestimonialBox.module.css";

interface Props {
  image: string;
  name: string;
  country: string;
  description: string;
}

const TestimonialBox: FC<Props> = ({ image, name, country, description }) => {
  return (
    <div className={styles.container}>
      <div className={styles.box__top}>
        <div className={styles.image__container}>
          <img src={image} alt="" />
        </div>
        <div className={styles.text__container}>
          <h3>{name}</h3>
          <h5>{country}</h5>
        </div>
      </div>
      <p>{description}</p>
    </div>
  );
};

export default TestimonialBox;
